<div class='form-group'>
  <label *ngIf='label'>{{label}}</label>
  <label *ngIf='customLabel'><ng-content></ng-content></label>
  <select
    class="form-control"
    [disabled]="disabled"
    [(ngModel)]="selectedValue" 
    (change)="updateFormSelectValue()" 
    [name]="selectName"
    [ngModelOptions]="{ standalone: true }"
  >
    <option 
        *ngFor="let option of selectOptions" 
        [value]="option.value">
        {{option.label}}
    </option>
  </select>
  <app-form-help-text [helpText]="helpText"></app-form-help-text>
</div>